import {
  LOAD_SMS_GROUPS_REQUEST,
  LOAD_SMS_GROUPS_SUCCESS,
  LOAD_SMS_GROUPS_FAILURE,
  CREATE_SMS_GROUP_REQUEST,
  CREATE_SMS_GROUP_SUCCESS,
  CREATE_SMS_GROUP_FAILURE,
  LEAVE_SMS_GROUP_REQUEST,
  LEAVE_SMS_GROUP_SUCCESS,
  LEAVE_SMS_GROUP_FAILURE,
  REMOVE_GROUP_PARTICIPANT_REQUEST,
  REMOVE_GROUP_PARTICIPANT_SUCCESS,
  REMOVE_GROUP_PARTICIPANT_FAILURE,
  ADD_GROUP_PARTICIPANT_REQUEST,
  ADD_GROUP_PARTICIPANT_SUCCESS,
  ADD_GROUP_PARTICIPANT_FAILURE,
  UPDATE_GROUP_SETTINGS_REQUEST,
  UPDATE_GROUP_SETTINGS_SUCCESS,
  UPDATE_GROUP_SETTINGS_FAILURE
} from '../actions/constants';

const initialState = {
  list: {},
  loading: false,
  error: null
};

const smsGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SMS_GROUPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
      
    case LOAD_SMS_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          [action.projectId]: action.payload
        },
        error: null
      };
      
    case LOAD_SMS_GROUPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
      
    case CREATE_SMS_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
      
    case CREATE_SMS_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };
      
    case CREATE_SMS_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
      
    case LEAVE_SMS_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
      
    case LEAVE_SMS_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          [action.projectId]: (state.list[action.projectId] || []).filter(group => group.id !== action.payload)
        },
        error: null
      };
      
    case LEAVE_SMS_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
      
    case REMOVE_GROUP_PARTICIPANT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case REMOVE_GROUP_PARTICIPANT_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case REMOVE_GROUP_PARTICIPANT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case ADD_GROUP_PARTICIPANT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case ADD_GROUP_PARTICIPANT_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case ADD_GROUP_PARTICIPANT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case UPDATE_GROUP_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case UPDATE_GROUP_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case UPDATE_GROUP_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
      
    default:
      return state;
  }
};

export default smsGroupsReducer;
